import React from 'react';
import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  current: number;
  total: number;
  animated?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, animated = false }) => {
  const progress = Math.min((current / total) * 100, 100);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <span className={styles.step}>
          Étape {current} sur {total}
        </span>
      </div>

      <div className={styles.barWrapper}>
        <div
          className={`${styles.bar} ${animated ? styles.barAnimated : ''}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
